var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChatDialogExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18064_220006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26647 3.33334L2.76647 0.833344L1.88259 1.71723L19.4872 19.3219L20.3711 18.438L17.6744 15.7412H17.7002C19.1858 15.7412 20.1654 14.7347 20.1654 13.1754V9.17545C20.1654 7.60308 19.1858 6.70834 17.7002 6.70834H11.2712C10.4422 6.70834 9.79677 6.96412 9.37563 7.4425L8.68608 6.75295C9.23791 6.14073 10.0706 5.80703 11.122 5.80703H15.6631L15.6566 5.55703C15.5593 4.20834 14.6835 3.33334 13.1979 3.33334H5.26647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83203 5.80045C1.83203 5.05473 2.05423 4.45972 2.44746 4.04102L7.92368 9.51724V13.386C7.92368 14.4583 8.2221 14.9254 8.58539 15.2215L6.69757 17.0044C6.39266 17.2939 6.21101 17.4189 5.95152 17.4189C5.58822 17.4189 5.37414 17.1557 5.37414 16.7478V14.8333H4.29724C2.81163 14.8333 1.83203 13.8268 1.83203 12.261V5.80045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81245 13.1754V10.406L16.6883 18.2818C16.6152 18.3154 16.5306 18.3333 16.4351 18.3333C16.1756 18.3333 15.994 18.2018 15.6891 17.9123L13.3471 15.7412H11.2712C9.72068 15.7412 8.81245 14.7347 8.81245 13.1754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18064_220006",
    x: 0.832031,
    y: 0.833344,
    width: 20.5391,
    height: 20.4885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18064_220006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18064_220006",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatDialogExit);
export default __webpack_public_path__ + "static/media/icon-chat-dialog-exit.aab62cdca2511f123581a624b12086b8.svg";
export { ForwardRef as ReactComponent };